import styled from "styled-components";
import { MediaQueries } from "ratel-ui";

export const Container = styled.div`
  .box {
    border-radius: 16px;
    box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

export const WaitingWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 32px 64px 48px;
  background: #ffffff;
  min-height: calc(100vh - 64px);
  overflow: hidden;

  ${MediaQueries.mobile`
    padding: 20px 12px 32px;
  `}
`;

export const CardFrame = styled.div`
  position: relative;
  width: 100%;
  max-width: 1024px;
`;

const StarBase = styled.span`
  position: absolute;
  display: block;
  pointer-events: none;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }

  ${MediaQueries.mobile`
    display: none;
  `}
`;

export const StarYellow = styled(StarBase)`
  top: 48px;
  left: -44px;
  width: 32px;
  height: 32px;
  transform: rotate(-12deg);
`;

export const StarGreen = styled(StarBase)`
  top: 104px;
  right: -36px;
  width: 24px;
  height: 24px;
  transform: rotate(15deg);
`;

export const StarBlue = styled(StarBase)`
  bottom: 88px;
  left: -32px;
  width: 20px;
  height: 20px;
  transform: rotate(-8deg);
`;

export const StarRed = styled(StarBase)`
  bottom: 64px;
  right: -32px;
  width: 18px;
  height: 18px;
  transform: rotate(-20deg);
`;

export const Time = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  height: 100%;
  min-height: calc(100vh - 333px);
  margin-top: 16px;
  border-radius: 16px;
  border: 1px solid ${props => props.theme.colors.font7};
  font-size: 1rem;

  ${MediaQueries.mobileTablet`
    min-height: calc(100vh - 280px);
  `}
`;

export const Title = styled.span`
  display: block;
  padding-bottom: 16px;
  font-weight: 600;
  font-size: 1.125rem;
  color: ${props => props.theme.colors.bg2};

  svg {
    fill: ${props => props.theme.colors.success};
    margin-right: 8px;
  }
`;

export const Item = styled.span`
  display: block;
  font-size: 0.875rem;
  color: ${props => props.theme.colors.font1};
  padding-bottom: 6px;

`;

export const Bold = styled.span`
  font-weight: 600;
`;

export const SimulatedHeader = styled.div`
  padding-top: 24px;
  padding-left: 32px;
  padding-bottom: 48px;
  font-family: 'Rubik', sans-serif;
  background-color: #eeeeee;
  position: relative;
`;

export const HeaderTitle = styled.h1`
  font-size: 2.5rem;
  font-weight: 700;
  color: #FD7138;
  letter-spacing:0;
  @media (max-width: 414px) {
    font-size: 2rem;
  }
  @media (min-width: 320px) and (max-width: 767px) {
    margin-top:16px;
  }
`;

export const HeaderSubTitle = styled.span`
  font-size: 0.875rem;
  font-weight: 600;
  color: #00C5E6;

  > strong{
  padding-left: 8px;
  font-size: 0.75rem;
  color: #003558;
    }
`;

export const IconPosition = styled.div`
  position:absolute;
  top: 15px;
  right: 48px;
  width: 34px;

 
  @media (min-width: 320px) and (max-width: 767px) {
    top: -15px;
    right: 5px;
    width: 32px;
  }
  /* @media (min-width: 414px) and (max-width: 767px) {
    top: 16px;
    right: 16px;
    width: 32px;
  } */
  
`;

export const Logo = styled.img``;
